module.exports = __webpack_public_path__ + "img/QR1.5dd69a7d.jpg";